import { Heading, Paragraph } from "@/components/ui/Typography"
import { WebsitePageSection } from "@/types"
import EditableSection from "@/components/admin/Content/WebPages/EditableSection";
import { Check } from "lucide-react";


const WhatWeDo = ({data}:{data: WebsitePageSection}) => {
  return (
    <EditableSection
      sectionTag={data.sectionTag}
      contentType={data.contentType}
      data={data}
    >
      <div className="grid md:grid-cols-2 gap-4 w-full p-4 md:p-8 lg:p-12 xl:p-16 bg-wine-100">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-4 text-white">
            <Paragraph className="text-white py-1 px-3 flex items-center justify-center !text-sm bg-wine-200 rounded-2xl w-fit">What We Do</Paragraph>
          </div>

          <Heading className="text-white" level={3} >{data.sectionTitle ?? "Default Title"}</Heading>

          <ul className="flex flex-col gap-4  text-white list-none">
            { Array.isArray(data.listOfPurpose) &&
              data.listOfPurpose.map((item, index) => (
                <li key={index} className="grid grid-cols-[1.5rem_1fr] items-start gap-2">
                  <Check className="rounded-full bg-wine-200 p-1" size={24} />
                  <Paragraph className="text-white">{item}</Paragraph>
                </li>
              ))
            }
          </ul>
        </div>
        <div className="w-full h-full">
          <img src={data.fileUrl ?? "/blank-image-placeholder.png" } alt={data.title ?? "Image"} className="w-full object-contain" />
        </div>
      </div>
    </EditableSection>
  )
}

export default WhatWeDo